import { useEffect, useState } from "react";
import Jobs from "../../lists/components/jobs/Jobs";
import { getPrmJobs } from "../../../../api/PRMAPI";
import { useParams } from "react-router-dom";
import { useProfileStore } from "../../../../stores/UserStore";

const LeadsJobs = ({ loading, setLoading }) => {
  const profile = useProfileStore((s) => s.profile);
  const { userId } = useParams();
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    if (loading) {
      getPrmJobs(userId || profile?.id)
        .then((res) => {
          setJobs(res.data.jobs);
        })
        .finally(() => setLoading(false));
    }
  }, [loading, profile?.id, userId]);

  return <Jobs isPrm row={{ state_details: jobs }} setLoading={setLoading} />;
};

export default LeadsJobs;
